import { AbsoluteCenter } from '@chakra-ui/react';

import { Box, ButtonIcon, Show, Typography } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { Nullable } from 'shared_DEPRECATED/types';

import {
  ParticipantsTableActionWrapper,
  ParticipantsTableCounter,
} from 'features/participants/components/Table/Actions/';

type TParticipantTableNotesButton = {
  onClick: () => void;
  unreadCount: number;
  unreadItemDateTime: Nullable<string>;
};

export const ParticipantTableNotesButton = ({
  onClick,
  unreadCount,
  unreadItemDateTime,
}: TParticipantTableNotesButton) => (
  <ButtonIcon
    aria-label="open notes"
    onClick={onClick}
    size="sm"
    variant="ghost"
    data-testid="participant-notes-btn"
  >
    <ParticipantsTableActionWrapper>
      <Box position="relative">
        <Show when={unreadCount > 0}>
          <AbsoluteCenter insetY="45%">
            <Typography
              as="span"
              color="black"
              type="xsm"
              data-testid="unread-new-note-counter-participant-list"
            >
              {unreadCount}
            </Typography>
          </AbsoluteCenter>
        </Show>
        <Box data-testid="message-icon-container">
          <Icon name={iconNames.message} width="21px" height="21px" />
        </Box>
        {unreadItemDateTime && (
          <ParticipantsTableCounter
            value={unreadItemDateTime}
            dataTestid="journal-unread-item-time"
          />
        )}
      </Box>
    </ParticipantsTableActionWrapper>
  </ButtonIcon>
);
